import React, { useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../assets/images";
import Select from "react-select";
import { DropDownUserType } from "../Jobs/RecurringJobReport/RecurringJobReportHeader";
import { DropDownType } from "../../commonTypes/clientDirectoryTypes";
import { SelectOptionType } from "../../redux/scheduling/schedulingTypes";
import { UsersDepartment } from "../../screens";

type AppProps = {
  setClearFilter: (data: boolean) => void;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  finalBranchDataList: any;
  branch: DropDownUserType[];
  // handleBranchDropDownChange: (data: any) => void;
  branchFetching: boolean;
  setBranchText: React.Dispatch<React.SetStateAction<string>>;
  setDesignationText: React.Dispatch<React.SetStateAction<string>>;
  desigationText: string;
  setListBranch: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  listBranch: DropDownUserType;
  setActiveListBranch: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  setFinalDesignationList: React.Dispatch<
    React.SetStateAction<DropDownUserType>
  >;
  activeListBranch: DropDownUserType;
  finalDesignationList: DropDownUserType;
  designationListData: any;
  checkBranchBottom: (e: any) => void;
  toggle: boolean;
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
  skillsText?: string;
  setSkillsOffset?: React.Dispatch<React.SetStateAction<number>> | undefined;
  setSkillsText?: React.Dispatch<React.SetStateAction<string>>;
  finalSkillList?: DropDownType[] | [];
  checkSkillsBottom: (e: any) => void;
  checkDesignationBottom: (e: any) => void;
  selectedSkill: DropDownType[] | [];
  setSelectedSkill: React.Dispatch<React.SetStateAction<DropDownType[] | []>>;
  setDesignation: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  designation: DropDownUserType;
  designationText?: string;
  finalSkill: DropDownType[] | [];
  selectedFinalSkill: React.Dispatch<React.SetStateAction<DropDownType[] | []>>;
  skillFetching?: boolean;
  setDesignationOffset?: React.Dispatch<React.SetStateAction<number>>;
  designationOffset: number;
  finalUsersDepartmentList: any;
  department: DropDownUserType;
  setDepartment: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  usersDepartmentText: string;
  setUsersDepartmentOffset: React.Dispatch<React.SetStateAction<number>>;
  setUsersDepartmentText: React.Dispatch<React.SetStateAction<string>>;
  checkUsersDepartmentBottom: (e: any) => void;
  finalDepartmentList?: DropDownUserType;
  setFinalDepartmentList: React.Dispatch<
    React.SetStateAction<DropDownUserType>
  >;
};

const TeamDirectoryFilter = ({
  setClearFilter,
  setOffset,
  finalBranchDataList,
  branch,
  // handleBranchDropDownChange,
  branchFetching,
  setBranchText,
  setListBranch,
  listBranch,
  setActiveListBranch,
  activeListBranch,
  checkBranchBottom,
  toggle,
  setToggle,
  skillsText,
  finalSkillList,
  setSkillsOffset,
  setSkillsText,
  checkSkillsBottom,
  checkDesignationBottom,
  selectedSkill,
  setSelectedSkill,
  selectedFinalSkill,
  finalSkill,
  skillFetching,
  designationListData,
  setDesignation,
  designation,
  setDesignationText,
  setDesignationOffset,
  designationText,
  designationOffset,
  setFinalDesignationList,
  finalDesignationList,
  finalUsersDepartmentList,
  department,
  setDepartment,
  usersDepartmentText,
  setUsersDepartmentOffset,
  setUsersDepartmentText,
  checkUsersDepartmentBottom,
  finalDepartmentList,
  setFinalDepartmentList,
}: AppProps) => {
  const resetFilterData = () => {
    // setActiveStatusValue(activeStatus.toString());
    setActiveListBranch(listBranch);
  };
  const handleSubmit = () => {
    setListBranch(activeListBranch);
    selectedFinalSkill(selectedSkill);
    setClearFilter(false);
    setFinalDesignationList(designation);
    setFinalDepartmentList(department);
  };

  const onMenuClose = () => {
    // setLoadCondition(true);
    setOffset(0);
  };

  const handleListBranchDropDownChange = (data: any) => {
    setActiveListBranch({ label: data?.label, value: data?.value });
  };
  const handleSkillDropDownChange = (e: any) => {
    setSelectedSkill(e);
  };

  const handleDesignationDropDownChange = (e: any) => {
    setDesignation(e);
  };
  const handleDepartmentChange = (department: SelectOptionType) => {
    setDepartment(department);
  };

  const clearFilter = () => {
    setListBranch({ label: "Select...", value: null });
    setActiveListBranch({ label: "Select...", value: null });
    setDesignation({ label: "Select...", value: null });
    setSelectedSkill([]);
    setFinalDesignationList({ label: "Select...", value: null });
    selectedFinalSkill([]);
    setOffset(0);
    setClearFilter(true);
    setDepartment({ label: "Select...", value: null });
    setFinalDepartmentList({ label: "Select...", value: null });
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle ||
          listBranch?.value ||
          finalSkill[0]?.value ||
          finalDesignationList?.value ||
          finalDepartmentList?.value
            ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
            : { border: "1px solid#bfcbe1" }
        }
        outline
      >
        <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />

        <span
          className={
            listBranch?.value ||
            finalSkill[0]?.value ||
            finalDesignationList?.value ||
            finalDepartmentList?.value
              ? "filter-count"
              : undefined
          }
        >
          {/* <span>{(approvalValue && attachmentValue && commentValue && filterStartDateValue && filterEndDateValue) ? 5 : (approvalValue || attachmentValue || commentValue  || filterEndDateValue || filterStartDateValue) ? 1 : "" }</span> */}
          <span>
            {[
              listBranch?.value,
              finalSkill[0]?.value,
              finalDesignationList?.value,
              finalDepartmentList?.value,
            ].filter(Boolean).length || ""}
          </span>
        </span>
      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <div>
              <div className="col-md-12 p-0">
                <label className="mb-1" htmlFor="">
                  Branch
                </label>
                <Select
                  options={
                    finalBranchDataList?.length
                      ? [...finalBranchDataList]
                      : finalBranchDataList
                  }
                  value={activeListBranch}
                  onChange={(e) => handleListBranchDropDownChange(e)}
                  isSearchable={true}
                  isLoading={branchFetching}
                  onMenuClose={onMenuClose}
                  onMenuScrollToBottom={(e: any) => checkBranchBottom(e)}
                  onInputChange={(e: any) => {
                    setBranchText(e);
                    setOffset(0);
                  }}
                />
              </div>
            </div>
            <div>
              <div className="col-md-12 p-0">
                <label className="mb-1 mt-4" htmlFor="">
                  Skills
                </label>

                <Select
                  className="dropdown"
                  placeholder={"Select..."}
                  value={selectedSkill}
                  options={finalSkillList}
                  isMulti
                  isClearable
                  onChange={(e) => handleSkillDropDownChange?.(e)}
                  isSearchable={true}
                  isLoading={skillFetching && (skillsText?.length || 0) > 0}
                  onMenuClose={() => setSkillsOffset?.(0)}
                  onMenuScrollToBottom={(e: any) => checkSkillsBottom(e)}
                  onInputChange={(e) => {
                    setSkillsText?.(e);
                  }}
                />
              </div>
            </div>
            <div>
              <div className="col-md-12 p-0">
                <label className="mb-1 mt-4" htmlFor="">
                  Designation
                </label>

                <Select
                  className="dropdown"
                  placeholder={"Select..."}
                  value={designation}
                  options={designationListData}
                  onChange={(e) => handleDesignationDropDownChange?.(e)}
                  isLoading={
                    skillFetching && (designationText?.length || 0) > 0
                  }
                  onMenuClose={() => setDesignationOffset?.(0)}
                  onMenuScrollToBottom={(e: any) => checkDesignationBottom(e)}
                  onInputChange={(e) => {
                    if (designationOffset === 0) {
                      setDesignationText?.(e);
                    } else {
                      setDesignationOffset?.(0);
                    }
                  }}
                />
              </div>
            </div>

            <div>
              <div className="col-md-12 p-0">
                <label className="mb-1 mt-4" htmlFor="department">
                  Department
                </label>
                <div className="mt-1">
                  <Select
                    options={
                      finalUsersDepartmentList?.length > 0
                        ? [
                            { label: "All Departments", value: null },
                            ...finalUsersDepartmentList,
                          ]
                        : []
                    }
                    value={department}
                    onChange={(department: any) =>
                      handleDepartmentChange(department)
                    }
                    isSearchable={true}
                    isLoading={
                      skillFetching && (usersDepartmentText?.length || 0) > 0
                    }
                    onMenuClose={() => setUsersDepartmentOffset?.(0)}
                    onMenuScrollToBottom={checkUsersDepartmentBottom}
                    onInputChange={(e) => {
                      setUsersDepartmentText?.(e);
                      setUsersDepartmentOffset?.(0);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default TeamDirectoryFilter;
